var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.2 51.3",
    style: {
      enableBackground: "new 0 0 36.2 51.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E44D26;}\r\n\t.st1{fill:#F16529;}\r\n\t.st2{fill:#EBEBEB;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#264DE4;}\r\n\t.st5{fill:#2965F1;}\r\n\t.st6{fill:#DAB92D;}\r\n\t.st7{fill:#FFD839;}\r\n\t.st8{fill:#53C1DE;}\r\n\t.st9{fill:#002A41;}\r\n\t.st10{fill:#0071B5;}\r\n\t.st11{fill:#DF4F4F;}\r\n\t.st12{fill:#26262C;}\r\n\t.st13{fill:#CCCCCC;}\r\n\t.st14{fill:#A6120D;}\r\n\t.st15{fill:#B3B3B3;}\r\n\t.st16{fill:#DD1B16;}\r\n\t.st17{fill:#F2F2F2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3.3,47.1 0,10 36.3,10 33,47.1 18.1,51.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "18.2,48.1 30.1,44.7 33,13.1 18.2,13.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "18.2,26.8 12.2,26.8 11.7,22.2 18.2,22.2 18.2,17.6 18.1,17.6 6.7,17.6 6.9,18.8 8,31.4 18.2,31.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "18.2,38.7 18.1,38.7 13.1,37.3 12.8,33.6 10.3,33.6 8.2,33.6 8.8,40.8 18.1,43.4 18.2,43.4  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4,0h2.3v2.3h2.1V0h2.3v6.9H7.8V4.6H5.7v2.3H3.4V0L3.4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2,2.3h-2V0h6.3v2.3h-2v4.6h-2.3V2.3L13.2,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,0h2.4l1.5,2.4L23.9,0h2.4v6.9H24V3.5l-1.5,2.4h-0.1l-1.6-2.4v3.4h-2.2L18.5,0L18.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4,0h2.3v4.6H33v2.3h-5.6V0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "18.1,26.8 18.1,31.4 23.7,31.4 23.2,37.3 18.1,38.7 18.1,43.4 27.4,40.8 27.5,40.1 28.6,28.1  28.7,26.8 27.5,26.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "18.1,17.6 18.1,20.5 18.1,22.1 18.1,22.2 29.1,22.2 29.1,22.2 29.1,22.2 29.2,21.2 29.4,18.8  29.5,17.6  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.d688536e4ff347de1d8189388eb2ab63.svg";
export { ForwardRef as ReactComponent };